/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  
  Modified by yang@onerockwell
  
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  Handlebars Helper Functions
==============================================================================*/
Handlebars.registerHelper('ifnotunderscorefirst', function (a, options) {
    return (a.charAt(0) === '_') ? options.inverse(this) : options.fn(this);
});


/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
  Yang@onerockwell Added ShopifyAPI.addMultipleItems
==============================================================================*/
ShopifyAPI.addMultipleItems = function(data, callback, errorCallback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart');
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item);
                } else {
                    ShopifyAPI.onItemAdded(line_item);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.addItemFromForm = function(submitEvent, callback, errorCallback) {
    const form = submitEvent.target;
    const submitterId = submitEvent.originalEvent.submitter.id;
    
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function(jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function(line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                } else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function(XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);

                if (submitterId === 'BuyNow') {     
                    window.location.href = `https://${Shopify.shop}/checkout`
                }
            }
        };
    jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function(cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function() {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function(XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function(jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};



/*============================================================================
  Product Options
==============================================================================*/
ShopifyAPI.selectCallback = function(variant, selector) {
    // var moneyFormat = Shopify.money_format;
    var moneyFormat = theme.moneyFormat;
    // Selectors
    if (selector.domIdPrefix.split('-').length > 1) {
        var selectorArray = selector.domIdPrefix.split('-');
        var $addToCart = $('#AddToCart-' + selectorArray[1]);
        var $buyNow = $('#BuyNow' + selectorArray[1]);
    } else {
        var $addToCart = $('#AddToCart');
        var $buyNow = $('#BuyNow');
    }

    var $productWrapper = $addToCart.parents('.product-core'), // Defined the Product Dom Scope
        $productPrice = $productWrapper.find('.product-price'),
        $comparePrice = $productWrapper.find('.product-compare-price'),
        $errorMessages = $productWrapper.find('.error-messages')[0],
        $addToCartText = $productWrapper.find('.add-to-cart-text'),
        $productPreventPreorder = $productWrapper.find('.prevent-preorder'),
        $productEtaMessage = $productWrapper.find('.pre-order-message'),
        $productEtaMessageParent = $productEtaMessage.parent('.product-description'),
        $productPreOrderHiddenInput = $productWrapper.find('#pre-order'),
        $productPreOrderBadge = $productWrapper.find('.product-preorder-badge');
        $klarnaText = $('#klarna-text'); //.find('p');
        // console.log($productPreventPreorder);
        // console.log($klarnaText);
            
    if ($productEtaMessage.length > 0) {// is Pre-Order 
   //     if ($productPreventPreorder) {
   //         break;
   //     } else {
        var $productEtaDates = $productEtaMessage.data('eta-list').split(','),
            zeroInventoryVariants = $productWrapper.find('.zeroInventoryVariants').data('zero-inventory-variants').toString();
   //     }
    }

    // Reset error messages
    $($errorMessages).empty();

    // Variant
    if (variant) {

        // Select a valid variant if available
        if (variant.available) {
            console.log('01a: Variant available');
            $klarnaText.show();
            // Available, enable the submit button, change text, show quantity elements
            $addToCart.removeClass('disabled').prop('disabled', false);
            $buyNow.removeClass('hidden disabled').prop('disabled', false);
            if ($productEtaDates) {
                console.log('02a: Product ETA dates');
                $.each($productEtaDates, function(index, ff_eta_date){
                    // Fashion Flow Estimated Time Arrival Date, pull date substring from tag.
                    // tag format : ff::eta::[variant.barcode]_[date]
                    // console.log(ff_eta_date);
                    // console.log(variant.barcode);
                    // console.log(zeroInventoryVariants.indexOf(variant.id) >= 0);

                    if (ff_eta_date.indexOf(variant.barcode) >= 0 && zeroInventoryVariants.indexOf(variant.id) >= 0) {
                        $klarnaText.hide();
                        console.log('03a: ff tag found and variant has zero inventory');
                        if ($productPreventPreorder.length > 0) {
                            console.log('04a: Prevent it!');
                            $buyNow.addClass('hidden');
                            if (!$addToCart.hasClass('inquire')) {
                                $addToCartText.html("Sold Out");
                                $addToCart.addClass('disabled');
                                $addToCart.prop('disabled', true);
                                $buyNow.addClass('hidden');
                            }
                            
                            return false;
                        } else {
                            console.log('04b. else no PreventPreOrder');
                        var dateStr = ff_eta_date.split('_')[1];
                        var date = new Date(dateStr);
                        date = date.setDate(date.getDate()+8); // add 7 days to current date, 8 as current date start at am
                        date = new Date(date); // changed to int when days was added, convert back to date object
                        var month = date.getMonth()+1 > 9? date.getMonth()+1 : '0' + (date.getMonth()+1); // Month starts at 0, 0 = january, therefore + 1
                        var day = date.getDate() > 9? date.getDate(): '0' + date.getDate();
                        date = "Estimated ship date: " + month + '-' + day + '-' + date.getFullYear();  
        
                        $productEtaMessage.html(date);
                        $productEtaMessageParent.addClass('has-message');
                        $productPreOrderHiddenInput.val(date);
                        $productPreOrderHiddenInput.attr("disabled",false);
                        $addToCart.addClass('pre-order');
                        $addToCart.find('.add-to-cart-text').html("Pre Order");
                        $buyNow.addClass('hidden');
                        $productPreOrderBadge.html("Pre Order"); 
                        return false;
                        }
                    } else if (index + 1 === $productEtaDates.length) { // loop end, doesn't find ff tag 
                        console.log('03b: no ff tag found or positive inventory');
                        $productEtaMessage.html('');
                        $productEtaMessageParent.removeClass('has-message');
                        $productPreOrderHiddenInput.val('');
                        $productPreOrderHiddenInput.attr("disabled",true);
                        $addToCart.removeClass('pre-order');
                        $addToCart.find('.add-to-cart-text').html("Add to Bag");
                        $buyNow.removeClass('hidden');
                        $productPreOrderBadge.html(''); 
                    }
                });
            } else {
                console.log('02b: no ETA dates');
                $addToCart.find('.add-to-cart-text').html("Add to Bag");
                $buyNow.removeClass('hidden');
            }
        } else {
            console.log('01b: else sold out');
            // Sold out, disable the submit button, change text, hide quantity elements
            $productEtaMessage.html('');
            $productEtaMessageParent.removeClass('has-message');
            $klarnaText.hide();
            $addToCart.addClass('disabled').prop('disabled', true);
            $buyNow.addClass('hidden');
            if (!$addToCart.hasClass('inquire')) {
                $addToCartText.html("Sold Out");
                $buyNow.addClass('hidden');
            }
        }
        // console.log('variant selected and update price');
        // console.log(selector);
        // Regardless of stock, update the product price
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat).replace('.00', ''));

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat).replace('.00', '')).show();
        } else {
            $comparePrice.hide();
        }

    } else {
        //Reset ATC button text
        $addToCartText.html("Add to Bag");


        if((!variant && selector.selectors[0].name == 'size') || (!variant && selector.selectors[1].name == 'size')){
            $buyNow.removeClass('hidden');
        }else{
            if (!$addToCart.hasClass('inquire')) {
            $addToCartText.html("Sold Out");
            $buyNow.addClass('hidden');
            }
        }
    }
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $currFormContainer, $addToCart, $currentAddToCart, addToCartSelector, $cartCountSelector, $cartCountTextSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, updateRecommendedProducts, sanitizeRecommendedProducts, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function(options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            cartCountTextSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $currFormContainer = '';
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $currentAddToCart = '';
        addToCartSelector = settings.addToCartSelector;
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCountTextSelector = $(settings.cartCountTextSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {
            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function() {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function(cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if ($cartCountTextSelector.length > 0) {
                var itemPluralize = cart.item_count === 1 ? " Item" : " Items";
                $cartCountTextSelector.html(itemPluralize);
            }

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
                $cartCountSelector.parents('.block-minicart').removeClass('has-items');
            }else{
                $cartCountSelector.parents('.block-minicart').addClass('has-items');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }
    };

    formOverride = function() {
        $formContainer.on('submit', function(evt) {
            evt.preventDefault();
            var proceed = true;
            var $currForm = $(evt.target);
            $currFormContainer = $currForm;
            $currentAddToCart = $currForm.find(addToCartSelector);
            var $selects = $currForm.find('select');
            const $errorMessages = $currForm.find('.error-messages')[0];
            const newErrorMessages = [];

            // Reset error messages
            $($errorMessages).empty();

            // Look for unselected product options and generate error messages
            $.each($selects, function(i, v) {
                if (v.labels.length <= 0) return true // Skip select element that's not for product option select
                const label = v.labels[0].textContent;

                if (v.value == '') {
                    const $newErrorMessage = document.createElement('p');

                    // Can be made more general later if client wants. Using specific error messaging for now.
                    if (label.toLowerCase() === 'color') {
                        $newErrorMessage.textContent = 'Select a color above';
                    }
                    if (label.toLowerCase() === 'size') {
                        $newErrorMessage.textContent = 'Select a size above';
                    }

                    newErrorMessages.push($newErrorMessage);
                }
            });

            if (newErrorMessages.length > 0) {
                newErrorMessages.forEach($errorMessage => {
                    $errorMessages.appendChild($errorMessage);
                })

                return false;
            }

            // Add class to be styled if desired
            if ($currentAddToCart.length) {
                $currentAddToCart.removeClass('is-added').addClass('is-adding');
                $currentAddToCart.find('.add-to-cart-text').html('Adding...');
            }

            // Remove any previous quantity errors
            $('.qty-error').remove();

            ShopifyAPI.addItemFromForm(evt, itemAddedCallback, itemErrorCallback);
        });
    };

    itemAddedCallback = function(product) {
        if ($currentAddToCart.length) {
            $currentAddToCart.removeClass('is-adding').addClass('is-added');
            $currentAddToCart.find('.add-to-cart-text').html('Added');
        }
        setTimeout(function(){  
            if ($currentAddToCart.length) {
                $currentAddToCart.removeClass('is-added');
                if($currentAddToCart.hasClass('pre-order')) {
                    $currentAddToCart.find('.add-to-cart-text').html('Pre Order');
                } else {
                    $currentAddToCart.find('.add-to-cart-text').html('Add To Bag');
                }
            }
        },3000);
        ShopifyAPI.getCart(function(cart) {
            cartUpdateCallback(cart);
            $body.trigger('afterAddToCart.ajaxCart', [cart, $currentAddToCart]);
        });
        
    };

    itemErrorCallback = function(XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if ($currentAddToCart.length) {
            $currentAddToCart.removeClass('is-adding is-added');
        }

        if (!!data.message) {
            if (data.status == 422) {
                if ($currFormContainer.length) {
                    $currFormContainer.after('<div class="errors qty-error">' + data.description + '</div>')
                }
            }
        }
    };

    cartUpdateCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    sanitizeRecommendedProducts = function($container) {
        if (!$container || !$container.length) return;

        $container.find('*').addBack().contents().each(function() {
            if (this.nodeType === 3 && $.trim(this.nodeValue) === 'undefined') {
                this.nodeValue = '';
            }
        });
    };

    updateRecommendedProducts = function() {
        // Update Listrak recommended products block
        if (_ltk.Recommender) {
            _ltk.Recommender.Render(function() {
                sanitizeRecommendedProducts($('.ajaxcart__recommended-products'));

                // Re-init Ajax Cart with newly created add to cart selectors
                $('.add-to-cart-form').off('submit');
                ajaxCart.init({
                    formSelector: '.add-to-cart-form',
                    addToCartSelector: '.add-to-cart-btn',
                    cartContainer: '.minicart-container',
                    cartCountSelector: '.minicart-count',
                    cartCostSelector: '#CartCost',
                    moneyFormat: theme.moneyFormat
                });
            });
            _ltk.Recommender.Render('.ajaxcart__recommended-products');
        }
    };

    buildCart = function(cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            var sourceEmpty = $("#CartTemplateEmpty").html(),
            templateEmpty = Handlebars.compile(sourceEmpty);
            
            $cartContainer.append(templateEmpty());

            updateRecommendedProducts();
            
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);

        console.log(cart.items);

        // Add each item to our handlebars.js data
        $.each(cart.items, function(index, cartItem) {
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
             */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Create item's data object and add to 'items' array
            item = {
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                variation: cartItem.variant_title,
                properties: cartItem.properties,
                itemAdd: cartItem.quantity + 1,
                itemMinus: cartItem.quantity - 1,
                itemQty: cartItem.quantity,
                price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
                vendor: cartItem.vendor,
                linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat).replace('.00', ''),
                originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat).replace('.00', ''),
                discounts: cartItem.discounts,
                discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
                isGiftCard: cartItem.gift_card,
                hasCompareAtPrice: cartItem.properties["_compareAtPrice"] ? true : false,
                compareAtPrice: cartItem.properties["_compareAtPrice"],
                altText: cartItem.title
            };

            items.push(item);
        });

        // Gather all cart data and add to DOM
        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat).replace('.00', ''),
            totalCartDiscount: cart.total_discount === 0 ? 0 : "\u003cp\u003eYou're saving\u003c\/p\u003e".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
            totalCartDiscountApplied: cart.total_discount === 0 ? false : true
        }

        $cartContainer.append(template(data));

        updateRecommendedProducts();

        cartCallback(cart);
    };

    cartCallback = function(cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    };

    adjustCart = function() {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, '')),
                qtyEvent = '';

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
                qtyEvent = "add_to_cart"
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
                qtyEvent = "subtract_from_cart"
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });

        $body.on('click', '.ajaxcart__qty-remove', function(e) {
            e.preventDefault();
            var $el = $(this),
                line = $el.data('line'),
                qtyEvent = "remove_from_cart";

            if (isUpdating) {
                return;
            }
            $body.trigger('changeCartItemQty.ajaxCart', [line, qtyEvent]);
            updateQuantity(line, 0);
        });

        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function(evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function() {
            var $el = $(this);
            setTimeout(function() {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.parent().addClass('is-removed');
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function() {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function() {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function(cart) {});
        });
    };

    adjustCartCallback = function(cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function() {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function() {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function() {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function() {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input.enable-qty-selector');
        if (numInputs.length) {
            numInputs.each(function() {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function() {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function(qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));